export type MapScreenViewMode = "live" | "select" | "timeline";

export type MapSelectionTool = "pointer" | "rectangle" | "lasso";

export type MapDeliveryJobStatus =
  | "unassigned"
  | "pending"
  | "delivered"
  | "failed"
  | "in_route";

export type MapDeliveryJob = {
  id: string;
  pickingId?: number;
  stopId?: number;
  routeId?: number;
  routeName?: string;
  name: string;
  pickingNumber?: string;
  partnerName?: string;
  address?: string;
  customerName?: string;
  lat: number;
  lng: number;
  status: MapDeliveryJobStatus;
  sequence?: number;
  scheduledDate?: string;
  driverName?: string;
  loads?: number;
};

export type MapScreenDriver = {
  id: number;
  name: string;
  lat: number;
  lng: number;
  isOnDuty?: boolean;
  routeId?: number;
  routeName?: string;
  vehicleType?: string;
  jobCount?: number;
};

export type MapTimelineStop = {
  id: string;
  label: string;
  sequence: number;
  routeId: number;
  routeName: string;
};

export function isMapJobSelectable(job: { status: string }): boolean {
  return job.status === "unassigned";
}

export type MapTimelineDriverRow = {
  id: number;
  name: string;
  vehicleType: string;
  routeId: number;
  routeName: string;
  jobCount: number;
  hasAlert?: boolean;
  stops: MapTimelineStop[];
  startHour: number;
  endHour: number;
};
